import React, { useEffect, useState } from 'react'
import './sharePopup.scss'
import axios from 'axios';


const SharePopup = ({selectedVehicle,closeLocShare}) => {
    const [selectedHours, setSelectedHours] = useState(24);
    const [link, setLink] = useState(null)
    const [failedLink, SetFailedLink] = useState(false)
    const [copied,setCopied] = useState(false)
    useEffect(() => {
    },[selectedVehicle])
    const handleGetLocation = () => {
        const timeSelect = document.getElementById('time-select');
        const selectedHours = timeSelect ? timeSelect.value : '';
        const vehicleNo = selectedVehicle?.vehicleno;
      
        if (!selectedHours) {
          alert('Please select a duration in hours.');
          return;
        }
      
        if (!vehicleNo) {
          alert('Vehicle number not found.');
          return;
        }

        let startTime = moment(new Date()).unix()*1000
        let endTime = (moment(new Date()).unix()*1000) + (selectedHours * 60 * 60 * 1000)
        let body = {
            vehicleno: vehicleNo,
            starttime:startTime,
            endtime: endTime,
            token: window.getAuth().token,
            meta: {},
        }
        
        axios.post('https://livloc.intellicar.in/api/vehicle/livloc/control/createlink',body)
        .then((resp) => {
            if(resp.data.data !== null){
                setLink(resp.data.data.liveloclink)
            }
        }).catch(() => {
            SetFailedLink(true)
        })
      
        
        const linkElement = document.querySelector('.location-link a');
        const placeholder = document.querySelector('.link-placeholder');
      
        if (placeholder) placeholder.style.display = 'none';
        if (linkElement) {
          linkElement.href = link;
          linkElement.textContent = link;
          linkElement.style.display = 'inline-block';
        }
    }
    const handleCopyLink = () => {

      const textarea = document.createElement('textarea');
      textarea.value = link;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand('copy');
        setCopied(true)
      } catch (err) {
        console.error('Copy failed:', err);
      }
      document.body.removeChild(textarea);
      }
      
      
  return (
    <div className='popup-main'>
        <div className="popup-box">
            <div className="popup-header">
                <h2 className="popup-title">Share Location</h2>
            </div>

            <div className="popup-body">
                <div className="vehicle-info">
                <label>Vehicle No:</label>
                <span>{selectedVehicle.vehicleno}</span>
                </div>

                <div className="form-group">
                <label htmlFor="time-select">Select Duration (in hours)</label>
                <select id="time-select" value={selectedHours}  onChange={(e) => setSelectedHours(e.target.value)}>
                    <option  value="">-- Select hours --</option>
                    {Array.from({ length: 24 }, (_, i) => (
                    <option key={i + 1} value={i + 1} >
                        {i + 1} hour{i + 1 > 1 ? 's' : ''}
                    </option>
                    ))}
                </select>
                </div>

                <div className="location-link">
                <p className="link-placeholder">
                    Location link will appear here after fetching...
                </p>
                <a href={link} target="_blank" rel="noopener noreferrer">
                    {link}
                </a>
                {failedLink ? <span className='err-msg'>Failed to load link. Please try again.</span> : null}
                {link !== null ?<span className="copy-btn" onClick={() =>handleCopyLink()}> {copied ?<span>copied!</span>:<i className="fa fa-clone" aria-hidden="true"></i>}</span>: null}
                </div>
            </div>

            <div className="popup-footer">
                <button className="btn cancel-btn" onClick={() => {closeLocShare()}}>Close</button>
                <button className="btn primary-btn get-location-btn" onClick={handleGetLocation}>Get Location</button>
            </div>
        </div>

    </div>
  )
}

export default SharePopup